var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page',{attrs:{"status":"404","title":"We can't find the page you're looking for"}},[_c('p',[_vm._v("\n\t\tThe page you're trying to access doesn't appear to exist.\n\t")]),_vm._v(" "),_c('btn',{attrs:{"primary":"","raised":""},on:{"click":_vm.goBack}},[_vm._v("Go back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }